import { useState } from 'react'
import { Chip } from '@mui/material'
import './chips.scss'
import { ErrorMessage } from 'formik'

const Chips = ({ chipLabels, setFieldValue, chipsIdValues, idFieldName }) => {
  const [touch, setTouch] = useState(false)

  return (
    <>
      <div className='chip-div'>
        {chipLabels.map((label) => (
          <Chip
            className={chipsIdValues.includes(label.materialId) ? 'selected-chip material-chips' : 'material-chips'}
            key={label.materialName}
            label={label.materialName}
            onClick={() => {
              const currentIndex = chipsIdValues.indexOf(label.materialId)
              const newChipsId = [...chipsIdValues]
              if (currentIndex === -1) {
                newChipsId.push(label.materialId)
              } else {
                newChipsId.splice(currentIndex, 1)
              }
              setFieldValue(idFieldName, newChipsId)
              if (!newChipsId.length) {
                setTouch(true)
              } else {
                setTouch(false)
              }
            }}
            clickable
          />
        ))}
      </div>
      <ErrorMessage name={idFieldName} component='div' className='error-course-chips'/>
    </>
  )
}

export default Chips
